"use strict";
/*
 * Created on 2019-03-28
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../../core/utils");

var SelloutReleaseItemUpdate_1 = require("../../model/sellout/SelloutReleaseItemUpdate");

var SelloutReleaseItemUpdateConverter_1 = require("./SelloutReleaseItemUpdateConverter");
/**
 * @author Radek Beran
 */


var SelloutReleaseItemUpdateConverterImpl =
/*#__PURE__*/
function (_SelloutReleaseItemUp) {
  _inherits(SelloutReleaseItemUpdateConverterImpl, _SelloutReleaseItemUp);

  function SelloutReleaseItemUpdateConverterImpl() {
    _classCallCheck(this, SelloutReleaseItemUpdateConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemUpdateConverterImpl).apply(this, arguments));
  }

  _createClass(SelloutReleaseItemUpdateConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var update;

      switch (source.tag) {
        case SelloutReleaseItemUpdate_1.FinalPriceItemUpdate.TAG:
          update = new SelloutReleaseItemUpdate_1.FinalPriceItemUpdate(conversions.toBigNumber(source.finalPriceValue));
          break;

        case SelloutReleaseItemUpdate_1.EndDateItemUpdate.TAG:
          update = new SelloutReleaseItemUpdate_1.EndDateItemUpdate(utils_1.Utils.isValueMissing(source.endDate) ? null : conversions.toDate(source.endDate));
          break;

        case SelloutReleaseItemUpdate_1.PriceCodeItemUpdate.TAG:
          update = new SelloutReleaseItemUpdate_1.PriceCodeItemUpdate(utils_1.Utils.isValueMissing(source.priceCode) ? null : source.priceCode);
          break;

        case SelloutReleaseItemUpdate_1.MinPriceChangeItemUpdate.TAG:
          update = new SelloutReleaseItemUpdate_1.MinPriceChangeItemUpdate(utils_1.Utils.isValueMissing(source.minPriceChangeInPercent) ? null : conversions.toBigNumber(source.minPriceChangeInPercent));
          break;

        case SelloutReleaseItemUpdate_1.MaxPriceChangeItemUpdate.TAG:
          update = new SelloutReleaseItemUpdate_1.MaxPriceChangeItemUpdate(utils_1.Utils.isValueMissing(source.maxPriceChangeInPercent) ? null : conversions.toBigNumber(source.maxPriceChangeInPercent));
          break;

        case SelloutReleaseItemUpdate_1.MinMarginChangeItemUpdate.TAG:
          update = new SelloutReleaseItemUpdate_1.MinMarginChangeItemUpdate(utils_1.Utils.isValueMissing(source.minMarginChangeInPercent) ? null : conversions.toBigNumber(source.minMarginChangeInPercent));
          break;

        case SelloutReleaseItemUpdate_1.ExportedItemUpdate.TAG:
          update = new SelloutReleaseItemUpdate_1.ExportedItemUpdate(source.exported);
          break;

        case SelloutReleaseItemUpdate_1.CommentItemUpdate.TAG:
          update = new SelloutReleaseItemUpdate_1.CommentItemUpdate(source.comment);
          break;
      }

      return update;
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      result = Object.assign(result, {
        tag: source.tag
      });

      switch (source.tag) {
        case SelloutReleaseItemUpdate_1.FinalPriceItemUpdate.TAG:
          result = Object.assign(result, {
            finalPriceValue: conversions.fromBigNumber(source.finalPriceValue)
          });
          break;

        case SelloutReleaseItemUpdate_1.EndDateItemUpdate.TAG:
          result = Object.assign(result, {
            endDate: source.endDate !== null ? conversions.fromDate(source.endDate) : null
          });
          break;

        case SelloutReleaseItemUpdate_1.PriceCodeItemUpdate.TAG:
          result = Object.assign(result, {
            priceCode: source.priceCode !== null ? source.priceCode : null
          });
          break;

        case SelloutReleaseItemUpdate_1.MinPriceChangeItemUpdate.TAG:
          result = Object.assign(result, {
            minPriceChangeInPercent: source.minPriceChangeInPercent !== null ? conversions.fromBigNumber(source.minPriceChangeInPercent) : null
          });
          break;

        case SelloutReleaseItemUpdate_1.MaxPriceChangeItemUpdate.TAG:
          result = Object.assign(result, {
            maxPriceChangeInPercent: source.maxPriceChangeInPercent !== null ? conversions.fromBigNumber(source.maxPriceChangeInPercent) : null
          });
          break;

        case SelloutReleaseItemUpdate_1.MinMarginChangeItemUpdate.TAG:
          result = Object.assign(result, {
            minMarginChangeInPercent: source.minMarginChangeInPercent !== null ? conversions.fromBigNumber(source.minMarginChangeInPercent) : null
          });
          break;

        case SelloutReleaseItemUpdate_1.ExportedItemUpdate.TAG:
          result = Object.assign(result, {
            exported: source.exported
          });
          break;

        case SelloutReleaseItemUpdate_1.CommentItemUpdate.TAG:
          result = Object.assign(result, {
            comment: source.comment
          });
          break;
      }

      return result;
    }
  }]);

  return SelloutReleaseItemUpdateConverterImpl;
}(SelloutReleaseItemUpdateConverter_1.SelloutReleaseItemUpdateConverter);

exports.SelloutReleaseItemUpdateConverterImpl = SelloutReleaseItemUpdateConverterImpl;